/**
 * Marketing MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import {
  MARKETING_CORE_QUERY_KEY,
  MARKETING_RECORDS_PER_PAGE,
  fetchMarketingCoreFromApi,
} from "./marketingQueryApi";

export const marketingQueryClient = makeMv2QueryClient();
setupMv2CachePersist(marketingQueryClient, "marketing");

export function prefetchMarketing(currentPage = 1) {
  return marketingQueryClient.prefetchQuery({
    queryKey: [MARKETING_CORE_QUERY_KEY, currentPage, MARKETING_RECORDS_PER_PAGE],
    queryFn: ({ signal }) =>
      fetchMarketingCoreFromApi(currentPage, MARKETING_RECORDS_PER_PAGE, signal),
  });
}
